// extracted by mini-css-extract-plugin
export default {"root":"DepositAccount_root__2LiZI","header":"DepositAccount_header__7gzib","actions":"DepositAccount_actions__xZ3iZ"};